import { render, staticRenderFns } from "./SocialLinksList.vue?vue&type=template&id=7f38bc9c&scoped=true&"
import script from "./SocialLinksList.vue?vue&type=script&lang=ts&"
export * from "./SocialLinksList.vue?vue&type=script&lang=ts&"
import style0 from "./SocialLinksList.vue?vue&type=style&index=0&id=7f38bc9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f38bc9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
